export default "__VITE_ASSET__BTb0W$Jp__"